import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { DASHBOARD_FY_OPTIONS, getDefaultFySelection } from "../utils/dashboardFilters";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const FilterContext = createContext({});

export function FilterProvider({ children }) {
  const [filters, setFilters] = useState({ fy: getDefaultFySelection(), theme: "", grantee: "", trust: "", status: "" });
  const [viewMode, setViewMode] = useState("active");
  const [filterOptions, setFilterOptions] = useState({
    fy_options: DASHBOARD_FY_OPTIONS, theme_options: [], grantee_options: [], trust_options: [],
    data_available: false, data_error: null, data_sources: {}, default_fy: "FY 2025-26", default_fys: getDefaultFySelection(),
  });
  const [loadingFilters, setLoadingFilters] = useState(true);
  const [globalLoading, setGlobalLoading] = useState(false);

  useEffect(() => {
    axios.get(`${API}/filters`).then((r) => {
      const defaultFys = getDefaultFySelection();
      setFilterOptions({
        ...r.data,
        fy_options: DASHBOARD_FY_OPTIONS,
        default_fys: defaultFys,
        default_fy: "FY 2025-26",
      });
      setFilters((f) => ({ ...f, fy: defaultFys }));
    }).catch(console.error).finally(() => setLoadingFilters(false));
  }, []);

  if (loadingFilters) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm">Loading...</div>
      </div>
    );
  }

  return (
    <FilterContext.Provider value={{ filters, setFilters, filterOptions, loadingFilters, viewMode, setViewMode, globalLoading, setGlobalLoading, API }}>
      {children}
    </FilterContext.Provider>
  );
}

export const useFilters = () => useContext(FilterContext);
